export default __webpack_public_path__ + "static/expert_on_the_way_collab-085b9f0ebee9864fc616178385a6135d.svg";